export enum WorkShiftStatus {
  /** Nepotvrzená (přihlášená) směna. */
  Planned = "Planned",
  /** Potvrzená (odpracovaná) směna. */
  Worked = "Worked",
}
